var MILLISECONDS_TO_SECONDS = 1000;
export function calculateDateDiffInSeconds(startDate, endDate) {
    var diffInMiliseconds = endDate.getTime() - startDate.getTime();
    var diffInSeconds = Math.floor(diffInMiliseconds / MILLISECONDS_TO_SECONDS);
    return diffInSeconds;
}
